(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-carillas-dentales"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-casa-de-munecas"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-cocinita"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-perfume-feromonas-her-loss"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-protector-dental"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-tijera-funcional"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cd-hero-thumbs]').forEach(function (thumbsBox) {
      var landing = thumbsBox.closest('.cd-landing');
      var mainImg = landing ? landing.querySelector('.cd-hero__main img') : null;
      if (!mainImg) return;

      var thumbs = thumbsBox.querySelectorAll('.cd-hero__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var fullSrc = thumb.getAttribute('data-full-src');
          if (!fullSrc) return;

          mainImg.removeAttribute('srcset');
          mainImg.src = fullSrc;

          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });

    var stickyBars = document.querySelectorAll('.cd-sticky-cta');
    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      var landing = bar.closest('.cd-landing');
      var firstCta = landing ? landing.querySelector('#cd-cta-1') : null;
      if (!firstCta) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(firstCta);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
